/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

import Tiles from "@Tilesets/common/tiles.jsx";

// Tile Types Supported (Labels for Easy Use) [[geometry, texture, height], walkability?]
const T = Object.assign({}, { ...Tiles });
export default T;
